import { Heading, Stack, Spinner, SkeletonDisplayText } from "@shopify/polaris";
import { useEffect, useState } from "react";
import { SketchPicker } from "react-color";

function WidgetPreview({
  selectedElement,
  openedPanelId,
  widgetSetting,
  widgetSubscriptionOnlySetting,
  widgetStyleSetting,
  translations,
  ...props
}) {
  const [displayPurchaseOptionLabel, setdisplayPurchaseOptionLabel] = useState(
    false
  );
  const [purchaseOptionLabel, setpurchaseOptionLabel] = useState("");
  const [displayEachLabel, setdisplayEachLabel] = useState(true);
  const [eachLabelText, seteachLabelText] = useState("");
  const [displayDiscountBadge, setdisplayDiscountBadge] = useState(false);

  const [displaySubscriptionPopup, setdisplaySubscriptionPopup] = useState(
    false
  );
  const [subscriptionPopupLabel, setsubscriptionPopupLabel] = useState("");
  const [
    subscriptionPopupDescription,
    setsubscriptionPopupDescription,
  ] = useState("");

  const [discountBadgeText, setdiscountBadgeText] = useState("");
  const [hideSellingPlan, sethideSellingPlan] = useState(false);
  const [showSellingPlanAsText, setshowSellingPlanAsText] = useState(false);
  const [hideWidget, sethideWidget] = useState(false);
  const [hideRadio, sethideRadio] = useState(false);
  const [defaultSelection, setdefaultSelection] = useState("one-time-purchase");
  const [showLoading, setshowLoading] = useState(false);
  const [themeColor, setthemeColor] = useState("#ffffff");
  const displayLoading = () => {
    setshowLoading(true);
    setTimeout(() => {
      setshowLoading(false);
    }, 500);
  };

  const purchaseOptions = [
    {
      label: "One-time + Subscriptions",
      value: "1",
    },
    {
      label: "Subscriptions Only",
      value: "2",
    },
  ];
  const availablePlans = [
    {
      label: "More than 1",
      value: "1",
    },
    {
      label: "Equal to 1",
      value: "2",
    },
  ];

  const dummyData = {
    sellingPlanGroup: [
      {
        id: "one-time-purchase",
        type: "one-time-purchase",
        name: "One Time Purchase",
        price: "$10.00",
        sellingPlan: [],
      },
      {
        id: "subscription1",
        type: "subscription",
        name: "Selling plan group 1",
        price: "$9.00",
        deliveryLabel: "Deliver every",
        description:
          "This is a sample selling plan description to see how exactly the description looks on frontend in the subscription widgets.",
        sellingPlan: [
          {
            name: "Selling plan 1",
            discount: "10%",
            price: "$9.00",
          },
          {
            name: "Selling plan 2",
            discount: "20%",
            price: "$8.00",
          },
        ],
      },
      {
        id: "subscription2",
        type: "subscription",
        name: "Selling plan group 2",
        price: "$5.00",
        deliveryLabel: "Deliver every",
        sellingPlan: [
          {
            name: "Selling plan 3",
            discount: "50%",
            price: "$5.00",
          },
          {
            name: "Selling plan 4",
            discount: "60%",
            price: "$4.00",
          },
        ],
      },
    ],
  };

  const ColorIndicator = ({ color }) => {
    return (
      <div
        style={{
          width: "35px",
          height: "36px",
          border: "1px solid rgb(201 204 207)",
          borderRadius: "5px",
          fontWeight: 500,
          background: color,
          position: "relative",
          top: "-1px",
        }}
      ></div>
    );
  };

  const LoopColorPicker = ({ color, ...props }) => {
    const [popover, setpopover] = useState(false);

    let popoverElemnt = popover ? (
      <div style={{ marginTop: "5px", position: "absolute", zIndex: "1000" }}>
        <SketchPicker
          color={color}
          onChangeComplete={(val) => {
            props.changeColor(val.hex);
          }}
        />
      </div>
    ) : null;

    return (
      <div>
        <div
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "5px",
            fontWeight: 500,
          }}
          onClick={() => {
            setpopover(!popover);
          }}
        >
          <ColorIndicator color={color} />
        </div>
        {popoverElemnt}
      </div>
    );
  };

  const getStyleProperties = ({ input_value_json, input_options, name }) => {
    let value = {};
    input_options.map((option) => {
      if (input_value_json) {
        if (option === "fontSize" && input_value_json.fontSize) {
          value["font-size"] =
            input_value_json.fontSize + input_value_json.fontSizeType;
        } else if (option === "color" && input_value_json.color) {
          value["color"] = input_value_json.color;
        } else if (option === "accentColor" && input_value_json.accentColor) {
          value["accent-color"] = input_value_json.accentColor;
        } else if (option === "borderRadius" && input_value_json.borderRadius) {
          value["border-radius"] =
            input_value_json.borderRadius +
            input_value_json.borderRadiusSizeType;
        } else if (option === "fontWeight" && input_value_json.fontWeight) {
          value["font-weight"] = input_value_json.fontWeight;
        } else if (option === "background" && input_value_json.background) {
          value["background-color"] = input_value_json.background;
        } else if (option === "borderColor" && input_value_json.borderColor) {
          value["border-color"] = input_value_json.borderColor;
        } else if (
          option === "textTransform" &&
          input_value_json.textTransform
        ) {
          value["text-transform"] = input_value_json.textTransform;
        } else if (option === "fontStyle" && input_value_json.fontStyle) {
          value["font-style"] = input_value_json.fontStyle;
        } else if (option === "width" && input_value_json.width) {
          value["width"] =
            input_value_json.width + input_value_json.widthSizeType;
        } else if (option === "lineHeight" && input_value_json.lineHeight) {
          value["line-height"] =
            input_value_json.lineHeight + input_value_json.lineHeightSizeType;
        } else if (option === "borderWidth" && input_value_json.borderWidth) {
          value["border-width"] =
            input_value_json.borderWidth + input_value_json.borderWidthSizeType;
        } else if (option === "border" && input_value_json.border) {
          value["border"] = input_value_json.border;
        } else if (option === "opacity" && input_value_json.opacity) {
          value["opacity"] = input_value_json.opacity;
        } else if (option === "margin" && input_value_json.marginTop) {
          value[
            "margin"
          ] = `${input_value_json.marginTop}${input_value_json.marginSizeType} ${input_value_json.marginRight}${input_value_json.marginSizeType} ${input_value_json.marginBottom}${input_value_json.marginSizeType} ${input_value_json.marginLeft}${input_value_json.marginSizeType}`;
        } else if (option === "padding" && input_value_json.paddingTop) {
          value[
            "padding"
          ] = ` ${input_value_json.paddingTop}${input_value_json.paddingSizeType} ${input_value_json.paddingRight}${input_value_json.paddingSizeType} ${input_value_json.paddingBottom}${input_value_json.paddingSizeType} ${input_value_json.paddingLeft}${input_value_json.paddingSizeType}`;
        }
      }
    });
    return value;
  };

  const getStyleData = (rows) => {
    const PURCHASE_OPTION_LABEL_STYLE = "purchase_option_label_style";
    const WIDGET_FEILDSET = "widget_feildset";
    const SELLING_PLAN_GROUP_CONTAINER = "selling_plan_group_container";
    const SELLING_PLAN_GROUP_LABEL = "selling_plan_group_label";
    const SELLING_PLAN_LABEL = "selling_plan_label";
    const SELLING_PLAN_PRICE_LABEL = "selling_plan_price_label";
    const SELLING_PLAN_PRICE_SUBTITLE_LABEL =
      "selling_plan_price_subtitle_label";
    const SELLING_PLAN_DESCRIPTION_LABEL = "selling_plan_description_label";
    const SELLING_PLAN_SELECTOR = "selling_plan_selector";
    const SELLING_PLAN_DISCOUNT_BADGE = "selling_plan_discount_badge_style";
    const SUBSCRIPION_DETAILS_LABEL = "subscription_details_label";
    const SUBSCRIPION_DETAILS_POPUP = "subscription_details_popup";
    const SELLING_PLAN_GROUP_RADIO = "selling_plan_group_radio";
    const SUBSCRIPION_DETAILS_SELECTED = "selling_plan_group_selected";
    const EDIT_CSS_CLASSESS = "edit_css_classes";
    let settingsData = {
      style: [],
    };
    rows.map((row) => {
      if (row.key === PURCHASE_OPTION_LABEL_STYLE) {
        settingsData.style.push({
          id: "purchase_option_label",
          data: getStyleProperties(row),
        });
      } else if (row.key === WIDGET_FEILDSET) {
        settingsData.style.push({
          id: "widget_feildset",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_GROUP_RADIO) {
        settingsData.style.push({
          id: SELLING_PLAN_GROUP_RADIO,
          data: getStyleProperties(row),
        });
      } else if (row.key === SUBSCRIPION_DETAILS_SELECTED) {
        settingsData.style.push({
          id: SUBSCRIPION_DETAILS_SELECTED,
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_GROUP_CONTAINER) {
        settingsData.style.push({
          id: "selling_plan_group_container",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_GROUP_LABEL) {
        settingsData.style.push({
          id: "selling_plan_group_label",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_LABEL) {
        settingsData.style.push({
          id: "selling_plan_label",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_PRICE_LABEL) {
        settingsData.style.push({
          id: "selling_plan_price_label",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_DESCRIPTION_LABEL) {
        settingsData.style.push({
          id: "selling_plan_description_label",
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_PRICE_SUBTITLE_LABEL) {
        settingsData.style.push({
          id: SELLING_PLAN_PRICE_SUBTITLE_LABEL,
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_SELECTOR) {
        settingsData.style.push({
          id: SELLING_PLAN_SELECTOR,
          data: getStyleProperties(row),
        });
      } else if (row.key === SELLING_PLAN_DISCOUNT_BADGE) {
        settingsData.style.push({
          id: SELLING_PLAN_DISCOUNT_BADGE,
          data: getStyleProperties(row),
        });
      } else if (row.key === SUBSCRIPION_DETAILS_LABEL) {
        settingsData.style.push({
          id: SUBSCRIPION_DETAILS_LABEL,
          data: getStyleProperties(row),
        });
      } else if (row.key === SUBSCRIPION_DETAILS_POPUP) {
        settingsData.style.push({
          id: SUBSCRIPION_DETAILS_POPUP,
          data: getStyleProperties(row),
        });
      } else if (row.key === EDIT_CSS_CLASSESS) {
        settingsData.cssClassess =
          row.input_value_string || row.input_default_value_string;
      }
    });

    return settingsData;
  };
  const getExtraCss = (style, extraCss) => {
    let extraClasses = ``;
    let classList = {
      purchase_option_label: [".loop-purchase-options-label"],
      widget_feildset: [".loop-selling-plan-fieldset"],
      selling_plan_group_container: [
        ".loop-one-time-purchase-option",
        ".loop-subscription-group",
      ],
      selling_plan_group_label: [
        ".loop-one-time-purchase-option-label",
        ".loop-subscription-group-label",
      ],
      selling_plan_label: [".loop-selling-plan-selector-label"],
      selling_plan_selector: [".loop-selling-plan-selector"],
      selling_plan_price_label: [
        ".loop-one-time-purchase-option-price-amount",
        ".loop-subscription-group-price-amount",
      ],
      selling_plan_price_subtitle_label: [
        ".loop-one-time-purchase-option-price-quantity",
        ".loop-subscription-group-price-quantity",
      ],
      selling_plan_description_label: [
        ".loop-selling-plan-selector-description",
      ],
      selling_plan_discount_badge_style: [
        ".loop-subscription-group-discount-badge",
      ],
      subscription_details_label: [".loop-tooltip-label"],
      subscription_details_popup: [
        ".loop-tooltiptext",
        ".loop-container-arrow",
      ],
      selling_plan_group_radio: [".loop-subscription-group-radio"],
      selling_plan_group_selected: [".loop-subscription-group-selected"],
    };
    const getProperties = ({ id, data }) => {
      if (data) {
        let keys = Object.keys(data);
        let properties = "";
        keys.forEach((key) => {
          let value = data[key];
          properties = `${properties} ${key}: ${value} !important;`;
        });
        return properties;
      } else {
        return "";
      }
    };
    const getClassName = ({ id, data }) => {
      return classList[id] || [];
    };
    style.map((st) => {
      let classNames = getClassName(st);
      classNames.map((className) => {
        extraClasses =
          extraClasses +
          `
                ${className} {
                    ${getProperties(st)}
                }
            `;
      });
    });
    let animationClass = `
      .loop-blinking {
        border: 2px dashed royalblue !important;
        border-color: royalblue !important;
        animation-name: blinking;
        animation-duration: 1s;
        animation-iteration-count: 100;
      }
      @keyframes blinking {
        50% {
          border-color: #000 !important;
        }
      }
    `;

    if (extraCss) {
      extraClasses = `
        ${extraClasses}
        ${extraCss}
        `;
    }
    extraClasses = `
    ${extraClasses}
    ${animationClass}
    `;

    return extraClasses;
  };

  const [purchaseOption, setpurchaseOption] = useState(1);
  const [sellingPlanCount, setsellingPlanCount] = useState(1);
  const [sellingPlanGroupCount, setsellingPlanGroupCount] = useState(1);
  const [sellingPlanGroup, setsellingPlanGroup] = useState(
    dummyData.sellingPlanGroup
  );

  const SellingPlan = ({ sp }) => {
    return (
      <option class="loop-selling-plan-selector-option" value={sp.name}>
        {sp.name}
      </option>
    );
  };

  // loop-subscription-group-selected
  const SellingPlanGroup = ({ spg, index }) => {
    let className = "";
    if (index !== 0) {
      className = "loop-subscription-group loop-subscription-group-border-top";
    } else {
      className = "loop-subscription-group";
    }
    if (spg.id === defaultSelection) {
      className = " loop-subscription-group-selected " + className;
    }
    let classNamePlanLabel = "";
    if (spg.id === "one-time-purchase") {
      classNamePlanLabel = "loop-subscription-group-label one-time-purchase";
    } else {
      classNamePlanLabel = "loop-subscription-group-label";
    }
    let classNameDeliveryType = hideRadio
      ? "loop-subscription-group-selling-plans-container loop-left-margin-0 "
      : "loop-subscription-group-selling-plans-container";
    return (
      <div class={className}>
        <div class="loop-subscription-group-wrapper">
          {!hideRadio ? (
            <input
              id={spg.id}
              type="radio"
              class="loop-subscription-group-radio"
              name="selling_plan_group"
              checked={spg.id === defaultSelection ? true : false}
            />
          ) : null}
          <label for={spg.name} class={classNamePlanLabel}>
            {spg.name}
          </label>
          {index !== 0 && displayDiscountBadge ? (
            <div class="loop-subscription-group-discount-badge">
              {discountBadgeText}
            </div>
          ) : null}
        </div>
        <div class="loop-subscription-group-price-container">
          <div class="loop-subscription-group-price-amount">{spg.price}</div>
          {displayEachLabel ? (
            <div class="loop-subscription-group-price-quantity">
              {eachLabelText}
            </div>
          ) : null}
        </div>
        {!hideSellingPlan && spg.sellingPlan && spg.sellingPlan.length ? (
          <div class={classNameDeliveryType}>
            <div class="loop-selling-plan-selector-label">
              {spg.deliveryLabel}{" "}
              {showSellingPlanAsText && spg.sellingPlan && spg.sellingPlan[0]
                ? spg.sellingPlan[0].name
                : ""}
            </div>
            {!showSellingPlanAsText ? (
              <select
                class="loop-full-width loop-selling-plan-selector"
                name="selling_plan"
                id={spg.deliveryLabel}
              >
                {spg.sellingPlan.map((sp, ind) => {
                  return (
                    <SellingPlan sp={sp ? sp : {}} key={ind} index={ind} />
                  );
                })}
              </select>
            ) : null}
            {spg.description ? (
              <div class="loop-selling-plan-selector-description">
                {spg.description}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    let sellingPlanGroup = dummyData.sellingPlanGroup;
    if (Number(purchaseOption) === 2) {
      sellingPlanGroup = sellingPlanGroup.filter(
        (spg) => spg.type === "subscription"
      );
    }
    if (Number(sellingPlanCount) === 2) {
      sellingPlanGroup = sellingPlanGroup.map((spg) => {
        return {
          ...spg,
          sellingPlan: [spg.sellingPlan[0]].filter((s) => s),
        };
      });
      let hideSellingPlanSetting = widgetSetting.find(
        (setting) => setting.key === "hide_plan_selector_setting"
      );
      if (hideSellingPlanSetting) {
        sethideSellingPlan(hideSellingPlanSetting.is_enabled === 1);
      }
      let showSellingPlanAsTextSetting = widgetSetting.find(
        (setting) => setting.key === "show_plan_selector_as_text_setting"
      );
      if (showSellingPlanAsTextSetting) {
        setshowSellingPlanAsText(showSellingPlanAsTextSetting.is_enabled === 1);
      }
    } else {
      sethideSellingPlan(false);
      setshowSellingPlanAsText(false);
    }

    if (Number(purchaseOption) === 2 && Number(sellingPlanGroupCount) === 2) {
      if (Number(sellingPlanCount) === 2) {
        let hideWholeWidget = widgetSubscriptionOnlySetting.find(
          (setting) => setting.key === "hide_widget_setting"
        );
        sethideWidget(hideWholeWidget?.is_enabled);
      } else {
        sethideWidget(false);
      }

      let hideRadioButton = widgetSubscriptionOnlySetting.find(
        (setting) => setting.key === "hide_radio_button_setting"
      );
      sethideRadio(hideRadioButton?.is_enabled || false);
    } else {
      sethideWidget(false);
      sethideRadio(false);
    }

    if (Number(sellingPlanGroupCount) === 2) {
      let flag = true;
      sellingPlanGroup = sellingPlanGroup.filter((spg) => {
        if (spg.type === "subscription" && flag) {
          flag = false;
          return true;
        } else if (spg.type !== "subscription") {
          return true;
        }
        return false;
      });
    }

    let translationData = {};
    if (translations) {
      translations.map((translation) => {
        translationData[translation.key] = translation.value;
      });
    }

    if (widgetSetting) {
      let puchaseOptionsLabel = widgetSetting.find(
        (setting) => setting.key === "purchase_option_label_setting"
      );
      if (puchaseOptionsLabel) {
        setdisplayPurchaseOptionLabel(puchaseOptionsLabel.is_enabled);
        setpurchaseOptionLabel(translationData.widget_purchase_option_label);
      }

      sellingPlanGroup = sellingPlanGroup.map((spg) => {
        if (spg.type === "one-time-purchase") {
          return {
            ...spg,
            name: translationData.widget_one_time_puchase_label,
          };
        } else {
          return spg;
        }
      });

      let purchaseOptionOrder =
        widgetSetting.find(
          (setting) => setting.key === "purchase_option_order_setting"
        ) || {};
      if (purchaseOptionOrder) {
        let displayOneTimePurchaseOptionAtBottom =
          Number(purchaseOptionOrder.input_value_int) === 2 ? true : false;
        if (displayOneTimePurchaseOptionAtBottom) {
          let ontTime = sellingPlanGroup.filter(
            (s) => s.type === "one-time-purchase"
          );
          let subscription = sellingPlanGroup.filter(
            (s) => s.type === "subscription"
          );
          sellingPlanGroup = [...subscription, ...ontTime];
        }
      }

      let defaultSelection = widgetSetting.find(
        (setting) => setting.key === "default_option_selected_setting"
      );
      if (defaultSelection) {
        if (Number(defaultSelection.input_value_int) === 2) {
          setdefaultSelection("subscription1");
        } else if (Number(purchaseOption) === 2) {
          setdefaultSelection("subscription1");
        } else {
          setdefaultSelection("one-time-purchase");
        }
      }

      let eachLabel =
        widgetSetting.find(
          (setting) => setting.key === "each_label_visibility_setting"
        ) || {};
      if (eachLabel) {
        let displayEachLabel =
          Number(eachLabel.is_enabled) === 1 ? false : true;
        setdisplayEachLabel(displayEachLabel);
        seteachLabelText(translationData.widget_price_label_text);
      }

      let discountBadgeSetting =
        widgetSetting.find(
          (setting) => setting.key === "discount-badge-widget-setting"
        ) || {};
      if (discountBadgeSetting) {
        let displayDiscountBadge =
          Number(discountBadgeSetting.is_enabled) === 1 ? true : false;
        setdisplayDiscountBadge(displayDiscountBadge);
        if (translationData.widget_discount_badge_text) {
          setdiscountBadgeText(
            translationData.widget_discount_badge_text.replace(
              "{{discount_value}}",
              "10%"
            )
          );
        }
      }

      let subscriptionPopup =
        widgetSetting.find(
          (setting) => setting.key === "subscription-details-popup"
        ) || {};
      if (subscriptionPopup) {
        let displaySubscriptionPopup =
          Number(subscriptionPopup.is_enabled) === 1 ? true : false;
        setdisplaySubscriptionPopup(displaySubscriptionPopup);
        if (displaySubscriptionPopup) {
          setsubscriptionPopupLabel(
            translationData.widget_subscription_details_text
          );
          setsubscriptionPopupDescription(
            translationData.widget_subscription_details_body
          );
        }
      }
    }

    let styleData = getStyleData(widgetStyleSetting);
    const loopStyle = document.getElementById("loop-style");
    if (loopStyle) {
      loopStyle.innerHTML = getExtraCss(
        styleData.style || [],
        styleData.cssClassess
      );
    } else {
      var head = document.getElementsByTagName("head");
      const style = document.createElement("style");
      style.innerHTML = getExtraCss(
        styleData.style || [],
        styleData.cssClassess
      );
      style.setAttribute("id", "loop-style");
      head[0].appendChild(style);
    }
    setsellingPlanGroup(sellingPlanGroup);
  }, [
    purchaseOption,
    sellingPlanCount,
    sellingPlanGroupCount,
    widgetSetting,
    widgetSubscriptionOnlySetting,
    widgetStyleSetting,
    translations,
  ]);

  // useEffect(() => {
  //   displayLoading()
  // }, [openedPanelId]);

  useEffect(() => {
    let addedClassTo = null;
    let animationClass = document.getElementsByClassName("loop-blinking");

    if (animationClass.length > 0) {
      for (let i = 0; i < animationClass.length; i++) {
        let element = animationClass[i];
        element.classList.remove("loop-blinking");
      }
    }

    // if (openedPanelId === 0) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-purchase-options-label"
    //   );
    // } else if (openedPanelId === 1) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-fieldset"
    //   );
    // } else if (openedPanelId === 2) {
    //   addedClassTo = document.getElementsByClassName("loop-subscription-group");
    // } else if (openedPanelId === 3) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-label"
    //   );
    // } else if (openedPanelId === 4) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-discount-badge"
    //   );
    // } else if (openedPanelId === 5) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-selector-label"
    //   );
    // } else if (openedPanelId === 6) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-selector"
    //   );
    // } else if (openedPanelId === 7) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-price-amount"
    //   );
    // } else if (openedPanelId === 8) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-price-quantity"
    //   );
    // } else if (openedPanelId === 9) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-selector-description"
    //   );
    // } else if (openedPanelId === 10) {
    //   addedClassTo = document.getElementsByClassName("loop-tooltip-label");
    // } else if (openedPanelId === 11) {
    //   addedClassTo = document.getElementsByClassName("loop-tooltiptext");
    // }
    if (addedClassTo && addedClassTo.length > 0) {
      for (let i = 0; i < addedClassTo.length; i++) {
        let element = addedClassTo[i];
        element.classList.add("loop-blinking");
      }
    }
  }, [showLoading]);
  useEffect(() => {
    displayLoading();
  }, [openedPanelId]);

  useEffect(() => {
    let addedClassTo = null;
    let animationClass = document.getElementsByClassName("loop-blinking");

    if (animationClass.length > 0) {
      for (let i = 0; i < animationClass.length; i++) {
        let element = animationClass[i];
        element.classList.remove("loop-blinking");
      }
    }

    // if (selectedElement === 0) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-purchase-options-label"
    //   );
    // } else if (selectedElement === 1) {
    //   addedClassTo = document.getElementsByClassName("one-time-purchase");
    // } else if (selectedElement === 2) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-wrapper"
    //   );
    // } else if (selectedElement === 3) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-label"
    //   );
    // } else if (selectedElement === 5) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-price-container"
    //   );
    // } else if (selectedElement === 6) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-selector"
    //   );
    // } else if (selectedElement === 7) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-selector"
    //   );
    // } else if (selectedElement === 100) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-selling-plan-fieldset"
    //   );
    // } else if (selectedElement === 101) {
    //   addedClassTo = document.getElementsByClassName(
    //     "loop-subscription-group-wrapper"
    //   );
    // }

    if (addedClassTo && addedClassTo.length > 0) {
      for (let i = 0; i < addedClassTo.length; i++) {
        let element = addedClassTo[i];
        element.classList.add("loop-blinking");
      }
    }
  }, [selectedElement]);

  return (
    <div>
      {/* <Heading>Widget Preview</Heading>
      <TextStyle variation="subdued">
        See how the subscription widget will appear on a product page in
        different configurations
      </TextStyle>
      <br/> */}
      {/* <br/> */}
      <div
        style={{
          background: themeColor,
          borderRadius: "5px",
          padding: "20px",
          border: "1px solid #ccc",
        }}
      >
        {showLoading ? (
          <div>
            <SkeletonDisplayText size="medium" />
            <div style={{ marginBottom: "15px" }}></div>
            <div
              style={{
                width: "100%",
                minHeight: "200px",
                margin: "auto",
                padding: "100px 180px",
                border: "1px dashed royalblue",
                borderRadius: "5px",
              }}
            >
              <Spinner accessibilityLabel="Spinner example" size="large" />
            </div>
          </div>
        ) : null}
        {!hideWidget && !showLoading ? (
          <div>
            {displayPurchaseOptionLabel ? (
              <div class="loop-purchase-options-label">
                {purchaseOptionLabel}
              </div>
            ) : null}
            <div class="loop-selling-plan-fieldset">
              {sellingPlanGroup.map((spg, index) => {
                return (
                  <SellingPlanGroup
                    key={index}
                    index={index}
                    spg={spg ? spg : {}}
                  />
                );
              })}
            </div>
            {displaySubscriptionPopup ? (
              <div class="loop-tooltip">
                <div class="loop-tooltip-image">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 90 90"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tooltip_subscription_svg"
                  >
                    <path d="M45 0C20.1827 0 0 20.1827 0 45C0 69.8173 20.1827 90 45 90C69.8173 90 90 69.8174 90 45C90.0056 44.6025 89.9322 44.2078 89.7839 43.8389C89.6357 43.47 89.4156 43.1342 89.1365 42.8511C88.8573 42.568 88.5247 42.3432 88.158 42.1897C87.7912 42.0363 87.3976 41.9573 87 41.9573C86.6024 41.9573 86.2088 42.0363 85.842 42.1897C85.4753 42.3432 85.1427 42.568 84.8635 42.8511C84.5844 43.1342 84.3643 43.47 84.2161 43.8389C84.0678 44.2078 83.9944 44.6025 84 45C84 66.5748 66.5747 84 45 84C23.4253 84 6 66.5747 6 45C6 23.4254 23.4253 6 45 6C56.1538 6 66.3012 10.5882 73.4375 18H65.4062C65.0087 17.9944 64.614 18.0678 64.2451 18.2161C63.8762 18.3643 63.5405 18.5844 63.2573 18.8635C62.9742 19.1427 62.7494 19.4753 62.596 19.842C62.4425 20.2088 62.3635 20.6024 62.3635 21C62.3635 21.3976 62.4425 21.7912 62.596 22.158C62.7494 22.5247 62.9742 22.8573 63.2573 23.1365C63.5405 23.4156 63.8762 23.6357 64.2451 23.7839C64.614 23.9322 65.0087 24.0056 65.4062 24H79.8125C80.6081 23.9999 81.3711 23.6838 81.9337 23.1212C82.4963 22.5586 82.8124 21.7956 82.8125 21V6.59375C82.821 6.18925 82.7476 5.78722 82.5966 5.41183C82.4457 5.03644 82.2205 4.69545 81.9344 4.40936C81.6483 4.12327 81.3073 3.898 80.9319 3.7471C80.5565 3.5962 80.1545 3.52277 79.75 3.53125C79.356 3.53941 78.9675 3.62511 78.6067 3.78344C78.2458 3.94177 77.9197 4.16963 77.6469 4.45402C77.3741 4.73841 77.16 5.07375 77.0168 5.44089C76.8737 5.80803 76.8042 6.19977 76.8125 6.59375V12.875C68.6156 4.86282 57.3081 0 45 0ZM43.75 20.75C43.356 20.7582 42.9675 20.8439 42.6067 21.0022C42.2458 21.1605 41.9197 21.3884 41.6469 21.6728C41.3741 21.9572 41.16 22.2925 41.0168 22.6596C40.8737 23.0268 40.8042 23.4185 40.8125 23.8125V47.375C40.8116 47.7693 40.8883 48.16 41.0385 48.5246C41.1886 48.8892 41.4092 49.2207 41.6875 49.5L54.0938 61.9375C54.6573 62.5011 55.4217 62.8177 56.2188 62.8177C57.0158 62.8177 57.7802 62.5011 58.3438 61.9375C58.9073 61.3739 59.224 60.6095 59.224 59.8125C59.224 59.0155 58.9073 58.2511 58.3438 57.6875L46.8125 46.1875V23.8125C46.821 23.408 46.7476 23.006 46.5966 22.6306C46.4457 22.2552 46.2205 21.9142 45.9344 21.6281C45.6483 21.342 45.3073 21.1168 44.9319 20.9658C44.5565 20.8149 44.1545 20.7415 43.75 20.75Z"></path>
                  </svg>
                </div>
                <div class="loop-tooltip-label">{subscriptionPopupLabel}</div>
                <div class="loop-tooltiptext">
                  <div class="loop-container-arrow loop-container-arrow--tl"></div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: subscriptionPopupDescription,
                    }}
                  ></p>
                </div>
              </div>
            ) : null}
          </div>
        ) : hideWidget ? (
          <Heading>No widget will be shown.</Heading>
        ) : null}
      </div>
      <Stack alignment="center">
        {/* <Stack.Item>
          <div
            style={{
              margin: "15px 0",
              width: "190px",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            Choose your theme color
          </div>
        </Stack.Item> */}
        {/* <Stack.Item fill>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                margin: "15px 3px 15px 0 ",
                width: "170px",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              <TextField
                label="Color"
                labelHidden
                value={themeColor}
                onChange={(val) => {
                  let value = val ? val.toLowerCase() : "";
                  setthemeColor(value);
                }}
                autoComplete="off"
                align="right"
              />
            </div>
            <LoopColorPicker
              color={themeColor}
              changeColor={(val) => {
                setthemeColor(val);
              }}
            />
          </div>
        </Stack.Item> */}
      </Stack>
    </div>
  );
}

export default WidgetPreview;
